import { render, staticRenderFns } from "./PartnerIdentifier.vue?vue&type=template&id=68290f14&"
import script from "./PartnerIdentifier.vue?vue&type=script&lang=js&"
export * from "./PartnerIdentifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports